import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {SessionModel} from "../../orchestration/session.model";
import {Subscription} from "rxjs";
import {MessageLevel} from "../../notification/message/message";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {OrderModel} from "../order.model";
import {OrderEvents} from "../order-events";
import {OrderingContextEvents} from "../../ordering-context/ordering-context-events";

@Component({
    selector: "woa-order-errors-panel",
    templateUrl: "./order-errors-panel.component.html"
})
export class OrderErrorsPanelComponent implements OnInit, OnDestroy {
    MessageLevel = MessageLevel;

    subscriptions: Subscription = new Subscription();

    constructor(public orderModel: OrderModel,
                public orderingContextModel: OrderingContextModel,
                public sessionModel: SessionModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(OrderingContextEvents.storeDetailsChanged$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(OrderEvents.orderInitiationStatus$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-errors-panel/order-errors-panel.component.ts